<template>
<transition
	appear
	v-bind:css="false"
	v-on:before-enter="beforeEnterOverlayBg"
	v-on:enter="enterOverlayBg"
	v-on:leave="leaveOverlayBg"
	>
	<div class="detail-view intro pt-5 position-absolute" v-if="state.showIntro">
    <transition
      appear
      v-bind:css="false"
      v-on:before-enter="beforeEnterOverlay"
      v-on:enter="enterOverlay"
      v-on:leave="leaveOverlay"
    >
			<div class="rainbow-high intro-container">
				<div class="product-na"><img src="@/assets/imgs/na-na.png" /></div>
				<div class="product-cursor"><img src="@/assets/imgs/intro-hand.png" /></div>
				<div class="product-title" v-html="$t('landing_screen.title')"></div>
				<div class="product-info" v-html="$t('landing_screen.content')"></div>
				<a class="btn btn-lg start-btn" @click="actions.toggleIntro(false)" v-html="$t('landing_screen.cta_button_text')"></a>
			</div>
		</transition>

	</div>
</transition>
</template>

<script>
import { inject } from "vue";
import gsap from 'gsap';

export default {
  name: "IntroOverlay",
  setup() {
    const store = inject("store");
    return {
      state: store.state,
			actions: store.actions
    };
  },
  methods: {
    // GSAP transitions
    beforeEnterOverlayBg(el) {
      gsap.set(el, { opacity: 0});
    },
    enterOverlayBg(el, done) {
      gsap.to(el, 0.4, { opacity: 1, onComplete: done}).delay(0.5);
    },
    leaveOverlayBg(el, done) {
			let that = this;
      gsap.to(el, 0.4, { opacity: 0, onComplete: function(){
				that.actions.toggleIntro(false);
				that.actions.showProduct(true);
				done();
			} });
    },
    beforeEnterOverlay(el) {
      gsap.set(el, { opacity: 0, scale: 0.5}).delay(0.5);
    },
    enterOverlay(el, done) {
      gsap.to(el, 0.4, { opacity: 1, scale: 1, onComplete: done}).delay(0.5);
    },
    leaveOverlay(el, done) {
      gsap.to(el, 0.4, { opacity: 0, onComplete: done });
    }
	}
}
</script>

<style lang="scss">
.rainbow-high {
  .product-info p {
    font-size: 0.9em;
    color: #d1b65c;
    background: url("../../assets/imgs/txt-bg.png") no-repeat;
    background-size: contain;
    display: inline-block;
    padding: 6px 15px;
    font-size: 80%;
    width: 100%;
    margin: 10px 0px 0px;
    
    border: 2px #c3aa32 solid;
    border-radius: 10px;
    background: #050708;    
  }
}
</style>

<style scoped lang="scss">
.detail-view {
	top: 0;
	left: 0;
	width: 100%;
	align-items: center;

  &:before {
    background: url('../../assets/imgs/overlay-bg.jpg') no-repeat;
    background-size: cover;
    background-position: 50% 50%;
  }
  @media (max-width: 414px) {
    &:before {
      background-size: cover;
      opacity: 0.5;
    }
  }
	.intro-container {
    min-height: 395px;
    width: 80vw;
		max-width: 290px;
    background: url('../../assets/imgs/intro-bg.png') no-repeat;
		padding: 55px 20px 30px 20px;
    position: relative;
    background-size: contain;
    background-position: 50% bottom;
		color: #000;
		text-align: center;
		.product-cursor {
			img {
				width: 60px;
        margin-top: 2em;
			}
		}
    .product-na {
      position: absolute;
      top: -1.5em;
      left: 0;
      right: 0;
    }
		.product-title {
			font-family: 'Proxima Nova';
			letter-spacing: 1px;
			font-size: 1.3em;
			line-height: 1.3em;
      padding: 0px 5px;
			margin: 10px 0 4px;
      color: #fff;
		}
		.product-info {
      width: 80%;
      margin: 0 auto;

			// font-size: 0.9em;
      // color: #d1b65c;
      // background: url("../../assets/imgs/txt-bg.png") no-repeat;
      // background-size: contain;
      // display: inline-block;
      // padding: 6px 15px;
      // margin: 5px;
      // font-size: 80%;
      // width: 80%;
		}
		.start-btn {
			background: url("../../assets/imgs/btn-bg.png") no-repeat;
      background-size: cover;
			color: #212121;
      padding: 0.5rem 5rem;
      font-family: "Proxima Nova", Tahoma;
			font-weight: 700;
			margin: 15px 0;
      font-size: 14px;
		}
	}
}
</style>
